import { Component } from '@angular/core';
import { IonicPage, Events, NavController } from 'ionic-angular';
import { ToastProvider } from "../../providers/toast";
import { DeveloperProvider } from "../../providers/developers";
import { CustomErrorHandler } from "@questrade/flx-commons";

@IonicPage({
  name: 'extensions'
})
@Component({
  selector: 'page-extensions',
  templateUrl: 'extensions.html',
})

export class ExtensionsPage {
  public examplesCode: Array<{ subtitle?: String, title?: String, description?: String, img: String }>;
  public listOfExtensions: Array<{}>;

  constructor(private events: Events,
    private devProvider: DeveloperProvider,
    private navCtrl: NavController,
    private toast: ToastProvider,
    private customErrorHandler: CustomErrorHandler) {
    this.listOfExtensions = [];
  }

}



// WEBPACK FOOTER //
// ./src/pages/extensions/extensions.ts